import React, { useState } from "react";
import "./css/events.css";
import event1 from "./pdf/servicenow.pdf";
import { FaCalendarAlt } from "react-icons/fa";
import { FaClock, FaToggleOn, FaTags, FaPaperPlane } from "react-icons/fa";
import { FaFilePdf, FaWpforms } from "react-icons/fa";
import eventimg1 from "./img/event/bgimg.jpg";
import eventimg2 from "./img/event/bgimg2.jpg";
import servicenow from "./img/event/bannerlogo.png";
import { FaDownload } from "react-icons/fa";
import { Button } from "react-bootstrap";
import LeadFormModal from "./LeadFormModal";
import { useNavigate } from "react-router-dom";
import {
  FaLaptop,
  FaChalkboardTeacher,
  FaCogs,
  FaCode,
  FaUser,
} from "react-icons/fa";

// import { FaLocationArrow } from 'react-icons/fa';
import { FaLocationDot } from "react-icons/fa6";



const EventPage = () => {
  const [showModal, setShowModal] = useState(false);

  const [pdfUrl, setPdfUrl] = useState("");
  const [actionType, setActionType] = useState("view");
  const navigator = useNavigate();
  const pdfFileUrl =
    "/events/materials/ServiceNow_Summit_DC_Sep_23_2025_Tiara_Agentic_AI_Service_Desk_Automation_using_Voice_Agent_Live_Demo.pdf";

  const handleClick = (type) => {
    setActionType(type); // "view" or "download"
    setPdfUrl(pdfFileUrl);
    setShowModal(true);
  };

  const HandleRegister = () => {
    navigator('/snconfirmation');
  }

  return (
    <>



      <div className="event-page">
        <div className="event-banner" style={{ backgroundColor: "#183442" }}>
          <h1 className="banner-title">Our Latest <span style={{ color: "#62d74e" }}>Events</span></h1>
          {/* <h1 className="banner-title">Our Latest Event at</h1> */}
          {/* <img src={servicenow} className="img-event-banner" alt="ServiceNow Event Banner" /> */}
          {/* <p className="banner-subtitle">ServiceNow Summit D.C.</p> */}
        </div>
        <div className="event-container">
          {/* Left - Event Image */}
          <div className="event-card image-card card-flex" style={{ padding: "0" }}>
            <img src={eventimg2} alt="Event" className="event-image" />
          </div>
          {/* Center - Event Content */}
          <div className="event-card content-card">
            <h2 className="event-title">
              Specialized Training to get Certified in ServiceNow
            </h2>
            <p className="event-description">
              Training by ServiceNow Certified Experts
            </p>
            <ul className="event-details">
              <li>
                <strong>
                  <FaCalendarAlt style={{ marginRight: "6px", color: "#1e4995" }} />
                </strong>{" "}
                Training Starts on Wednesday, April 29, 2026
              </li>
              {/* <li><strong>Date:</strong> October 15, 2025</li> */}
              <li>
                <strong>
                  <FaToggleOn style={{ marginRight: "6px", color: "#1e4995" }} />{" "}
                </strong>{" "}
                Mode : Online / Classroom           </li>
              <li>
                <strong>
                  <FaTags style={{ marginRight: "6px", color: "#1e4995" }} />
                </strong>{" "}
                Type :  Functional, Technical, User
              </li>



            </ul>
            <div class="event-btn-container">
              <a
                onClick={() => HandleRegister()}
                target="_blank"
                rel="noopener noreferrer"
                className="brochure-button"
              >

                <span
                  style={{
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    padding: "5px 7px",
                    marginRight: "10px",
                  }}
                >
                  <FaPaperPlane style={{ color: "#205ebf" }} />
                </span>{" "}
                Register
              </a>{" "}
            </div>
          </div>
        </div>
        <div className="event-container">
          {/* Left - Event Image */}
          <div className="event-card image-card card-flex" style={{ padding: "0" }}>
            <img src={eventimg1} alt="Event" className="event-image" />
          </div>
          {/* Center - Event Content */}
          <div className="event-card content-card">
            <h2 className="event-title">
              Tiara Consulting | Agentic AI Service Desk:{" "}
            </h2>
            <p className="event-description">
              Live Voice Orchestration for ITSM/CSM/HRSD automation (e.g. Password
              Reset)
            </p>
            <ul className="event-details">
              <li>
                <strong>
                  <FaCalendarAlt style={{ marginRight: "6px", color: "#1e4995" }} />
                </strong>{" "}
                Tuesday, September 23, 2025
              </li>
              <li>
                <strong>
                  <FaClock style={{ marginRight: "6px", color: "#1e4995" }} />{" "}
                </strong>{" "}
                12:45 AM – 1:15 PM EST
              </li>
              <li>
                <strong>
                  <FaLocationDot style={{ marginRight: "6px", color: "#1e4995" }} />
                </strong>{" "}
                Marriott Marquis Washington D.C.
              </li>
            </ul>
            <div class="event-btn-container">
              <a
                onClick={() => handleClick("view")}
                target="_blank"
                rel="noopener noreferrer"
                className="brochure-button"
              >
                <span
                  style={{
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    padding: "5px 7px",
                    marginRight: "10px",
                  }}
                >
                  <FaFilePdf style={{ color: "#205ebf" }} />
                </span>{" "}
                View Presentation
              </a>{" "}

              <a
                onClick={() => handleClick("download")}
                rel="noopener noreferrer"
                className="brochure-button"
              >
                <span
                  style={{
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    padding: "5px 7px",
                    marginRight: "10px",
                  }}
                >
                  <FaDownload style={{ color: "#205ebf" }} />
                </span>{" "}
                Download
              </a>
            </div>

            <LeadFormModal
              show={showModal}
              onClose={() => setShowModal(false)}
              pdfUrl={pdfUrl}
              actionType={actionType}
              onSuccess={() => console.log(`${actionType} action completed`)}
            />
          </div>
        </div>

      </div>

    </>
  );
};

export default EventPage;
